import { Dispatch, FC, SetStateAction } from "react";
import TrackSessionHeader from "./TrackSessionHeader";
import TrackSessionQuestionList from "./TrackSessionQuestionList";
import { ITrackSessionQuestions, Question } from "@/utils/types";
import TrackFilters from "./TrackFilters";
import Loading from "react-loading";

interface Props {
  sessionName: string;
  sessionDescription: string;
  questions: ITrackSessionQuestions;
  setSelectedQuestions: Dispatch<SetStateAction<Question[]>>;
  setSelectedFilters: Dispatch<SetStateAction<string[]>>;
  filters: string[];
  selectedFilters: string[];
  query: string;
  setQuery: Dispatch<SetStateAction<string>>;
  setDifficulty: Dispatch<SetStateAction<string | null>>;
  startSession: ()=>void;
}

const TrackSession: FC<Props> = ({
  sessionName,
  sessionDescription,
  questions,
  setSelectedQuestions,
  filters,
  selectedFilters,
  setSelectedFilters,
  query,
  setQuery,
  setDifficulty,
  startSession
}) => {
  return (
    <div className="w-full text-left flex flex-col gap-4">
      <TrackSessionHeader
        sessionName={sessionName}
        sessionDescription={sessionDescription}
        startSession={startSession}
      />
      { Object.keys(questions).length === 0 &&
      <div className="loading">
          <Loading type="bubbles" color="#000000" height={200} width={100} />
        </div>
      }
      {  Object.keys(questions).length > 0 && <>
      <TrackFilters
        filters={filters}
        selectedFilters={selectedFilters}
        setSelectedFilters={setSelectedFilters}
        query={query}
        setQuery={setQuery}
        setDifficulty={setDifficulty}
      />
      <TrackSessionQuestionList
        questions={questions}
        setSelectedQuestions={setSelectedQuestions}
      />
      </>}
    </div>
  );
};

export default TrackSession;
